import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthService } from './core/auth/auth.service';
import { CookieconsentService } from './modules/admin/cookieconsent/services/cookieconsent.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit, AfterViewInit {
    private oidcSecurityService = inject(OidcSecurityService);
    private authService = inject(AuthService);
    private router = inject(Router);

    isAuthenticated: boolean = false;

    /**
     * Constructor
     */
    constructor(private cookieconsentService: CookieconsentService) {}

    ngOnInit() {
        // Si Cognito respondió con error=login_required, limpiar URL y restaurar ruta original
        if (this.authService.hasLoginRequiredError()) {
            console.log(
                'No hay sesión activa en Cognito, el usuario puede registrarse'
            );
            const savedUrl = this.authService.cleanErrorParams();
            this.isAuthenticated = false;
            if (savedUrl) {
                this.router.navigateByUrl(savedUrl);
            }
            return;
        }

        this.oidcSecurityService
            .checkAuth()
            .subscribe(({ isAuthenticated }) => {
                if (isAuthenticated) {
                    console.log('Usuario autenticado');
                    this.isAuthenticated = isAuthenticated;
                    this.cookieconsentService.almacenarPreferenciasWithUsuario();

                    // Restaurar la URL original si existe (después del redirect de Cognito)
                    const savedUrl =
                        this.authService.getAndClearSavedUrl();
                    if (savedUrl) {
                        this.router.navigateByUrl(savedUrl);
                    }
                } else if (!this.authService.wasSilentCheckAttempted()) {
                    // Primera visita: intentar detectar sesión de Moodle con prompt=none
                    console.log(
                        'Verificando sesión de Cognito (Moodle)...'
                    );
                    this.authService.silentCheckSession();
                } else {
                    console.log(
                        'No hay sesión activa, el usuario puede registrarse'
                    );
                    this.isAuthenticated = false;
                }
            });
    }

    ngAfterViewInit(): void {
        this.cookieconsentService.initCookieConsent();
    }
}
